module.exports = __webpack_public_path__ + "static/media/Ubuntu-Italic.9f353a17.ttf";